export default "__VITE_PUBLIC_ASSET__a5712605__"